import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CoffeeIcon from '@mui/icons-material/Coffee';

const SupportBox = ({ sx = {} }) => {
  return (
    <Box 
      sx={{ 
        mt: 1, 
        mb: 2, 
        p: 2, 
        mx: 'auto', // Wyśrodkowanie komponentu w poziomie
        textAlign: 'center', 
        backgroundColor: 'rgba(255, 255, 255, 0.03)', 
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        width: 'fit-content', // Ramka dopasowuje się do zawartości
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...sx // Pozwala na dodatkowe stylowanie przy wstawianiu
      }}
    >
      <Typography variant="body1" sx={{ color: '#ccc', mb: 2 }}>
        Podobają Ci się nasze symulacje? 
      </Typography>
      <Button
        variant="outlined"
        component="a"
        href="https://buycoffee.to/symuliga"
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<CoffeeIcon />}
        sx={{
          color: '#fff',
          borderColor: '#4caf50',
          '&:hover': {
            borderColor: '#66bb6a',
            backgroundColor: 'rgba(76, 175, 80, 0.1)',
          },
          textTransform: 'none',
          fontWeight: 'bold'
        }}
      >
        Postaw nam kawę i wesprzyj rozwój projektu
      </Button>
    </Box>
  );
};

export default SupportBox;